// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PostStats--wrapper--A1XvJ","dot":"PostStats--dot--kvdgr","author":"PostStats--author--3kkhh"};